import React from 'react';
import PropTypes from 'prop-types';
import { checkAuthorization } from 'api/taxi.rest.backend';
import FormPreview from '../../components/FormPreview';

class Preview extends React.Component { // eslint-disable-line react/prefer-stateless-function
  state = { isAuthorized: false }

  componentDidMount() {
    checkAuthorization()
      .then(() => this.setState({ isAuthorized: true }))
      .catch(() => this.setState({ isAuthorized: false }));
  }

  render() {
    const version = new URLSearchParams(this.props.location.search).get('version');
    const { formId } = this.props.match.params;
    return (
      <FormPreview
        formId={formId}
        isAuthorized={this.state.isAuthorized}
        version={version}
      />
    );
  }

}
Preview.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};
export default Preview;
